// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function assertUnreachable(_: never): never {
    throw new Error('This code is not allowed to be reached');
}
